import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { CommunicationService } from '../communication/communication.service';
import { UserpilotReloader } from '../helper/userpilot-reloader.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent extends UserpilotReloader implements OnInit {

  helpDocuments: { title: string, path: string }[] = [];
  srcs: Record<string, SafeResourceUrl> = {};

  constructor(
    private sanitizer: DomSanitizer,
    private commService: CommunicationService,
  ) {
    super();
  }

  ngOnInit() {
    (this.commService.getAllRequest('/dbapi/help-documents') as Observable<{ obj: HelpDocument[] }>)
      .pipe(take(1))
      .subscribe(data => {
        let documents = data.obj;
        documents.sort((a, b) => a.index - b.index);
        this.helpDocuments = [];
        for (const document of documents) {
          const path = `/dbapi/help-documents/${document.id}`;
          this.helpDocuments.push({
            title: document.name,
            path: path,
          });

          this.srcs[document.name] = this.getSanitizedPath(path)
        }
    });
  }

  openInNewTab(document: { title: string, path: string }) {
    const extension = '?extension=pdf#toolbar=0&navpanes=0';
    window.open(window.location.origin + document.path + extension);
  }

  getSanitizedPath(path: string) {
    // Ignore security warnings (unsafe value used in a resource URL context (see http://g.co/ng/security#xss))
    const extension = '?extension=png';
    return this.sanitizer.bypassSecurityTrustResourceUrl(path + extension);
  }
}

interface HelpDocument {
  id: string;
  name: string;
  product: string;
  index: number;
  pdfName: string;
  imgName: string;
};